"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _interopRequireWildcard2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/interopRequireWildcard"));


var _layout = _interopRequireDefault(require("@/layout"));
var _Empty = _interopRequireDefault(require("@/layout/Empty")); /*
                                                                	定义好所有菜单的路径及组件，用于匹配用户拥有的菜单，合并成用于拥有的路由
                                                                */ // import Accountgllist from '@/pages/permiss/accountgllist'
var _default = [
// 系统管理
{
  path: '/permiss',
  component: _layout.default,
  meta: { icon: 'user' },
  children: [
  {
    path: 'accountgllist',
    name: 'accountgllist',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/account'));});} },

  {
    path: 'menulist',
    name: 'permmenu',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/menu'));});} },

  {
    path: 'rolegllist',
    name: '角色管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/role'));});} },

  {
    path: 'rolefplist',
    name: '角色分配',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/roleAssign'));});} },

  {
    path: 'organization',
    name: '组织管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/organize'));});} },

  {
    path: 'operationLog',
    name: '操作日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/sys/operationLog'));});} }] },



{
  path: 'instructions',
  component: _layout.default,
  meta: { icon: 'instructs' },
  children: [
  {
    path: 'instructionslist',
    name: '指令列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/instruct/instructList'));});} },

  {
    path: 'instructionslistdetail/:parentId',
    name: '多国语言',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/instruct/instructListDetail'));});} },

  {
    path: 'classification',
    name: '分类管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/instruct/instructClassify'));});} },

  {
    path: 'template',
    name: '指令模板',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/instruct/instructTemplate'));});} },

  {
    path: 'program',
    name: '指令版本管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/instruct/program'));});} }] },



{
  path: 'model',
  component: _layout.default,
  meta: { icon: 'model' },
  children: [
  {
    path: 'modellist',
    name: '功能列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/modelList'));});} },

  {
    path: 'agreelist',
    name: '协议列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/agreeList'));});} },

  {
    path: 'agreement',
    name: '基础协议',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/agreement'));});} },

  {
    path: 'mqttuserlist',
    name: 'mqtt用户列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/mqttUserList'));});} },

  {
    path: 'mqttpowerlist',
    name: 'mqtt权限列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/mqttPowerList'));});} },

  {
    path: 'modeloption/:parentId',
    name: '配置功能',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/modelOption'));});} },

  {
    path: 'agreedetails',
    name: '协议列表-协议详情',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/agreeDetail/detailLayout'));});} },

  {
    path: 'agreementdetails',
    name: '基础协议-协议详情',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/model/agreeDetail/detailLayoutMent'));});} }] },



{
  path: 'voiceIntent',
  component: _layout.default,
  meta: { icon: 'model' },
  children: [
  {
    path: 'intention',
    name: '意图管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/tts/intentionList'));});} },

  {
    path: 'function',
    name: '功能管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/tts/functionList'));});} },

  {
    path: 'apply',
    name: '语音应用',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/tts/applyList'));});} },

  {
    path: 'reply',
    name: '回复设置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/tts/replyList'));});} }] },



{
  path: 'edition',
  component: _layout.default,
  meta: { icon: 'appEdition' },
  children: [
  {
    path: 'editionlist',
    name: 'APP版本',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/edition/editionList'));});} },

  {
    path: 'editionlistdetail/:parentId',
    name: 'APP版本详情',
    meta: { icon: 'star' },
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/edition/editionDetail'));});} },

  {
    path: 'logs',
    name: '版本日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/edition/editionLogs'));});} },

  {
    path: 'upgradeLog',
    name: 'App升级日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/edition/upgradeLog'));});} }] },



{
  path: 'news',
  component: _layout.default,
  meta: { icon: 'msg' },
  children: [
  {
    path: 'user',
    name: '用户信息',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/user'));});} },

  {
    path: 'userdetail/:parentId',
    name: '用户设备详情',
    meta: { icon: 'star' },
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/userDetail'));});} },

  {
    path: 'log',
    name: '设备日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/deviceLog'));});} },

  {
    path: 'fault',
    name: '故障信息',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/fault'));});} },

  {
    path: 'technique',
    name: '按摩手法',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/technique'));});} },

  {
    path: 'monitor',
    name: '设备监控',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/monitor'));});} },

  {
    path: 'problem',
    name: '问题反馈',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/problem'));});} },

  {
    path: 'soreness',
    name: '酸痛检测',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/soreness'));});} },

  {
    path: 'address',
    name: '地址信息',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/address'));});} },

  {
    path: '528U',
    name: '酸痛检测查询',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/528U'));});} },

  {
    path: 'evaluate',
    name: '用户评价信息',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/evaluate'));});} },

  {
    path: 'evaluateDetails/:parentId',
    name: '用户评价详情',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/evaluateDetails'));});} },

  {
    path: 'feedback',
    name: '意见反馈',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/msg/feedback'));});} }] },



{
  path: 'configure',
  component: _layout.default,
  meta: { icon: 'configure' },
  children: [
  {
    path: 'brand',
    name: '品牌管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/brand'));});} },

  {
    path: 'application',
    name: '应用管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/application'));});} },

  {
    path: 'model',
    name: '产品型号',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/model'));});} },

  {
    path: 'specialRecommend/:modelId',
    name: '特殊推荐',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/specialRecommend'));});} },

  {
    path: 'h5Version/:parentId/:name/:code',
    name: 'H5版本配置',
    hidden: true,
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/h5VersionRecord'));});} },

  {
    path: 'category',
    name: '品类管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/category'));});} },

  {
    path: 'currency',
    name: '通用APP管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/currency'));});} },

  {
    path: 'currencyDetail/:parentId',
    name: '绑定应用',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/currencyDetail'));});} },

  {
    path: 'currencyDetail2/:parentId',
    name: '绑定设备',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/currencyDetail2'));});} },

  {
    path: 'instructions',
    name: '电子说明书',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/instructions'));});} },

  {
    path: 'function',
    name: '产品功能配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/function'));});} },

  {
    path: 'recommend',
    name: '今日推荐配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/recommend'));});} },

  {
    path: 'configCondition/:parentId/:deviceCode',
    name: '配置条件',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/configCondition'));});} },

  {
    path: 'announcement',
    name: '系统公告通知',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/announcement'));});} },

  {
    path: 'domainName',
    name: '服务区域域名配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/domainName'));});} },

  {
    path: 'phoneCaptcha',
    name: '手机验证码配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/phoneCaptcha'));});} },

  {
    path: 'emailCaptcha',
    name: '邮箱验证码配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/emailCaptcha'));});} },

  {
    path: 'emailSender',
    name: '邮件发件人配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/emailSender'));});} },

  {
    path: 'country',
    name: '国家地区配置',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/country'));});} },

  {
    path: 'countryLanguage/:parentId/:parentName',
    name: '多国语言',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/countryLanguage'));});} },

  {
    path: 'serviceNotice/:parentId/:parentName',
    name: '服务和建议通知',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/configure/serviceNotice'));});} }] },



{
  path: 'test',
  component: _layout.default,
  meta: { icon: 'star' },
  children: [
  {
    path: 'test1',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/test/test1'));});},
    children: [
    {
      path: 'test11',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/test/test1'));});} },

    {
      path: 'test12',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/test/test1'));});} }] },



  {
    path: 'test2',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/test/test1'));});} }] },



{
  path: 'device',
  component: _layout.default,
  meta: { icon: 'device' },
  children: [
  {
    path: 'information',
    name: '设备信息',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/device/informations/informationsList'));});} },

  {
    path: 'informationdetail/:parentId/:regionalId/:deviceTypeId',
    name: '入库明细',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/device/informations/informationsDetails'));});} },

  {
    path: 'details',
    name: '设备查询',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/device/inquiry/inquiryList'));});} }] },



{
  path: 'voice',
  component: _layout.default,
  meta: { icon: 'voice' },
  children: [
  {
    path: 'voiceEdition',
    name: '语言版本',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/voice/voiceList'));});} },

  {
    path: 'voiceJournal',
    name: '版本日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/voice/logs/logList'));});} },

  {
    path: 'voiceUpdate/:parentId',
    name: '更新内容',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/voice/update/updateList'));});} },

  {
    path: 'voiceCompatible/:parentId',
    name: '升级范围',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/voice/upgrade/upgradeList'));});} }] },



{
  path: 'core',
  component: _layout.default,
  meta: { icon: 'center' },
  children: [
  {
    path: 'coreEdition',
    name: '中心版本',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/centerEdition/centerList'));});} },

  {
    path: 'coreJournal',
    name: '版本日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/centerEdition/logs/logList'));});} },

  {
    path: 'coreUpdate/:parentId',
    name: '更新内容',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/centerEdition/update/updateList'));});} },

  {
    path: 'coreCompatible/:parentId',
    name: '升级范围',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/centerEdition/upgrade/upgradeList'));});} }] },



{
  path: 'wifi',
  component: _layout.default,
  meta: { icon: 'wifi' },
  children: [
  {
    path: 'wifiEdition',
    name: '中心版本',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/wifi/wifiList'));});} },

  {
    path: 'wifiJournal',
    name: '版本日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/wifi/logs/logList'));});} },

  {
    path: 'wifiUpdate/:parentId',
    name: '更新内容',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/wifi/update/updateList'));});} },

  {
    path: 'wifiCompatible/:parentId',
    name: '升级范围',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/wifi/upgrade/upgradeList'));});} }] },



{
  path: 'firmware',
  component: _layout.default,
  meta: { icon: 'otaEdition' },
  children: [
  {
    path: 'upgrade',
    name: '设备固件升级',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/firmware/upgrade'));});} }] },



{
  path: 'xunfei',
  component: _layout.default,
  meta: { icon: 'otaEdition' },
  children: [
  {
    path: 'firmware',
    name: '固件版本',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/xunfei/xunfeiList'));});} },

  {
    path: 'journal',
    name: '版本日志',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/xunfei/logs/logList'));});} },

  {
    path: 'devicemanagement',
    name: '设备管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/xunfei/device/deviceList'));});} },

  {
    path: 'firmwaredetail/:parentId',
    name: '详情',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/xunfei/detail/detailList'));});} }] },



{
  path: 'robot',
  component: _layout.default,
  meta: { icon: 'robot' },
  children: [
  {
    path: 'common',
    name: '通用功能',
    meta: { icon: 'robot' },
    component: _Empty.default,
    children: [
    {
      path: 'infos',
      name: '机器人查看',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/robotInfoList'));});} },

    {
      path: 'employee',
      name: '通讯录',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/staff/staffList'));});} },


    {
      path: 'temperature',
      name: '体温记录',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/temperature/temperatureRecord'));});} }] },



  {
    path: 'quest',
    name: '任务',
    meta: { icon: 'robot' },
    component: _Empty.default,
    children: [
    {
      path: 'map',
      name: 'map',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/TEMI/map/mapTable'));});} },

    {
      path: 'point/:parentId',
      name: 'point',
      hidden: true,
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/TEMI/map/mapCenter'));});} },

    {
      path: 'skill',
      name: '技能管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/skillList'));});} },

    {
      path: 'task',
      name: '任务管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/task/taskTableList'));});} },

    {
      path: 'taskDetail/:parentId',
      name: '任务详情',
      hidden: true,
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/task/taskTable'));});} },

    {
      path: 'trigger',
      name: '触发事件',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/event/eventListClient'));});} }] },


  {
    path: 'introduce',
    name: '公司介绍',
    meta: { icon: 'robot' },
    component: _Empty.default,
    children: [
    {
      path: 'homepage',
      name: '主页内容设置',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/homepage/homepage'));});} },

    {
      path: 'propaganda',
      name: '宣传图片',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/propaganda/propaganda'));});} },

    {
      path: 'introduction',
      name: '公司简介设置',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/companyProfile/introduction'));});} },

    {
      path: 'news',
      name: '集团新闻管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/news/newsList'));});} },

    {
      path: 'story',
      name: '品牌故事管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/story/storyList'));});} },

    {
      path: 'culture',
      name: '企业文化设置',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/companyCulture/companyCulture'));});} }] },



  {
    path: 'medicalTreatment',
    name: '医疗功能',
    meta: { icon: 'robot' },
    component: _Empty.default,
    children: [
    {
      path: 'beds',
      name: '床位列表',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/beds/beds'));});} },

    {
      path: 'patients',
      name: '患者列表',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/patients/patients'));});} },

    {
      path: 'doctor',
      name: '医生列表',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/doctor/doctors'));});} },

    {
      path: 'doctorPatient/:parentId',
      name: '医生病人',
      hidden: true,
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/doctor/doctorPatients'));});} },

    {
      path: 'robots',
      name: '医疗机器人',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/robot/robots'));});} },

    {
      path: 'robotBeds/:parentId',
      name: '医生病人',
      hidden: true,
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/medical/robot/robotBeds'));});} }] }] },





{
  path: 'temi',
  component: _layout.default,
  meta: { icon: 'robot' },
  children: [
  {
    path: 'infos',
    name: '机器人管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/TEMI/info/infoList'));});} },

  {
    path: 'skill',
    name: '技能管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/TEMI/skill/skillList'));});} },

  {
    path: 'trigger',
    name: '触发事件',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/admin/event/eventAdminList'));});} },

  {
    path: 'company',
    name: '公司列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/robot/company/companyList'));});} }] },



{
  path: 'event',
  component: _layout.default,
  meta: { icon: 'robot' },
  children: [
  {
    path: 'login',
    name: '登录数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/loginEventData'));});} },

  {
    path: 'start',
    name: '开始数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/startEventData'));});} },

  {
    path: 'posture',
    name: '姿势数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/postureEventData'));});} },

  {
    path: 'light',
    name: '灯光数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/lightEventData'));});} },

  {
    path: 'location',
    name: '定位数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/locationEventData'));});} },

  {
    path: 'width',
    name: '宽度数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/widthEventData'));});} },

  {
    path: 'strength',
    name: '4D数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/strengthEventData'));});} },

  {
    path: 'air',
    name: '气压数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/airEventData'));});} },

  {
    path: 'knock',
    name: '敲击数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/knockEventData'));});} },

  {
    path: 'knead',
    name: '揉捏数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/kneadEventData'));});} },

  {
    path: 'senior',
    name: '高级数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/seniorEventData'));});} },

  {
    path: 'warm',
    name: '温感数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/warmEventData'));});} },

  {
    path: 'foot',
    name: '脚底数据',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/data/footEventData'));});} }] },



{
  path: 'city',
  component: _layout.default,
  meta: { icon: 'robot' },
  children: [
  {
    path: 'province',
    name: '省市列表',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/city/province'));});} },

  {
    path: 'citys/:parentId',
    name: '下级城市',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/city/citys'));});} },

  {
    path: 'county',
    name: '下级区县',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/city/county'));});} }] },



{
  path: 'joypal',
  component: _layout.default,
  meta: { icon: 'joypal' },
  children: [
  {
    path: 'music',
    name: '音乐',
    meta: { icon: 'joypal' },
    component: _Empty.default,
    children: [
    {
      path: 'category',
      name: '分类管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/joypal/category'));});} },

    {
      path: 'musicManage',
      name: '音乐管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/joypal/musicManage'));});} }] }] },





{
  path: 'ota',
  component: _layout.default,
  meta: { icon: 'star' },
  children: [
  {
    path: 'moduleFirm',
    name: '模块厂商管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/moduleFirm'));});} },

  {
    path: 'hardwareModule',
    name: '硬件模块维护',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/hardwareModule'));});} },

  {
    path: 'firmware',
    name: '固件版本管理',
    meta: { icon: 'star' },
    component: _Empty.default,
    children: [
    {
      path: 'ota/firmware/centralPlate',
      name: '中心板版本管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/firmware/centralPlate'));});} },

    {
      path: 'ota/firmware/wifi',
      name: 'WiFi板版本管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/firmware/wifi'));});} },

    {
      path: 'ota/firmware/voice',
      name: '语音板版本管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/firmware/voice'));});} },

    {
      path: 'ota/firmware/shank',
      name: '小腿板版本管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/firmware/shank'));});} },

    {
      path: 'ota/firmware/movement',
      name: '机芯板版本管理',
      meta: { icon: 'star' },
      component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/firmware/movement'));});} }] },



  {
    path: 'upgrade',
    name: 'OTA升级包管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/upgrade'));});} },

  {
    path: 'upgrade/situation/:parentId',
    name: '升级情况',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/situation'));});} },

  {
    path: 'upgrade/compatibleVersion/:parentId/:type/:deviceTypeId/:auditStatus',
    name: '兼容版本',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/compatibleVersion'));});} },

  {
    path: 'upgrade/upgradeContent/:parentId/:auditStatus',
    name: '更新内容',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/ota/upgradeContent'));});} }] },



{
  path: 'static',
  component: _layout.default,
  meta: { icon: 'star' },
  children: [
  {
    path: 'brand',
    name: '品牌管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/static/brand'));});} },

  {
    path: 'brand/model/:brandId',
    name: '产品型号',
    hidden: true,
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/static/model'));});} },

  {
    path: 'backend',
    name: '后台管理',
    meta: { icon: 'star' },
    component: function component() {return Promise.resolve().then(function () {return (0, _interopRequireWildcard2.default)(require('@/views/static/backend'));});} }] }];exports.default = _default;